window.AnnouncementFreeShipping = window.AnnouncementFreeShipping || (() => {
  const zeroDecimalCurrencies = new Set([
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'ISK',
    'JPY',
    'KMF',
    'KRW',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
  ]);

  function normalizeCountryCode(code) {
    const normalizedCode = (code || '').trim().toUpperCase();
    return normalizedCode === 'UK' ? 'GB' : normalizedCode;
  }

  function parseThresholds(config) {
    return (config || '')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .reduce((thresholds, line) => {
        const separatorIndex = line.indexOf(':');
        if (separatorIndex === -1) return thresholds;

        const countryCode = normalizeCountryCode(line.slice(0, separatorIndex));
        const threshold = Number(line.slice(separatorIndex + 1).trim());
        if (countryCode && Number.isFinite(threshold)) thresholds[countryCode] = threshold;
        return thresholds;
      }, {});
  }

  function getThresholdConfig(container) {
    const configScript =
      container.parentElement?.querySelector('[data-announcement-free-shipping-thresholds]') ||
      container.closest('.announcement-bar__announcement, .announcement-bar')?.querySelector(
        '[data-announcement-free-shipping-thresholds]'
      );

    if (!configScript) return '';

    try {
      return JSON.parse(configScript.textContent);
    } catch (error) {
      return configScript.textContent;
    }
  }

  function getRate(container) {
    const currencyIso = container.dataset.currencyIso;
    const shopCurrency = container.dataset.shopCurrency;

    if (currencyIso === 'USD') return 1;

    const shopifyCurrency = window.Shopify?.currency;
    const activeCurrency = shopifyCurrency?.active || currencyIso;
    const rate = Number(shopifyCurrency?.rate);

    if (shopCurrency === 'USD' && activeCurrency === currencyIso && Number.isFinite(rate) && rate > 0) {
      return rate;
    }

    return 1;
  }

  function formatMoney(amount, currencyIso) {
    const maximumFractionDigits = zeroDecimalCurrencies.has(currencyIso) ? 0 : 2;

    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyIso,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: maximumFractionDigits,
      maximumFractionDigits,
    }).format(amount);
  }

  function renderMessage(template, amount) {
    if (!template) return `Free Shipping Over ${amount}`;
    if (template.includes('{{ amount }}')) return template.replace(/\{\{\s*amount\s*\}\}/g, amount);
    if (template.includes('[amount]')) return template.replace(/\[amount\]/g, amount);
    return `${template} ${amount}`;
  }

  function refresh(container) {
    const countryCode = normalizeCountryCode(container.dataset.countryCode);
    const currencyIso = container.dataset.currencyIso || 'USD';
    const thresholds = parseThresholds(getThresholdConfig(container));
    const defaultThresholdUsd = Number(container.dataset.defaultThresholdUsd) || 50;
    const thresholdUsd = thresholds[countryCode] ?? thresholds.DEFAULT ?? defaultThresholdUsd;
    const convertedThreshold = Math.ceil(thresholdUsd * getRate(container));

    container.textContent = renderMessage(container.dataset.template, formatMoney(convertedThreshold, currencyIso));
  }

  function refreshAll(root = document) {
    root.querySelectorAll('[data-announcement-free-shipping]').forEach(refresh);
  }

  document.addEventListener('DOMContentLoaded', () => refreshAll());
  document.addEventListener('shopify:section:load', (event) => refreshAll(event.target));

  return {
    refresh,
    refreshAll,
  };
})();
